import React from "react";
import
{
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
const validator = require("../../../../utils/validator/validator");
const translator = require("../../../../utils/translator/translator");

class ItemCount extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.quantity = this.props.quantity;
        this.state.caption = this.props.caption;
        this.state.error = {};


        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.hasErrors = this.hasErrors.bind(this);
        this.inputFieldRef = React.createRef();
    }

    handleModalOpen()
    {
        this.inputFieldRef.current.focus();
    }

    hasErrors()
    {
        let error;

        if (!validator.isInteger(this.state.quantity) || (this.state.quantity * 1) < 1) 
        {
            error = {
                fieldName: 'quantity',
                message: translator.getLabel("quantity_should_be_a_number_greater_than_0")
            }
        }
        else
        {
            error = {
                fieldName: '',
                message: ''
            }
        }

        return error;
    }

    handleSubmit(e)
    {
        const error = this.hasErrors();
        this.setState({ error });
        if (!error.fieldName)
        {
            if (this.props.onSubmit != null)
            {
                this.props.onSubmit(this.state.quantity);
            }
        }
    }

    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false}
                   onOpened={this.handleModalOpen} size="lg">
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.props.onClose}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                            <Button className="btn-ok" type="submit" form="openDiscountForm">{translator.getLabel("done")}</Button>
                        </div>
                    }
                >
                    <span className="window-title">{this.props.caption}</span>
                </ModalHeader>
                <ModalBody>
                    <Form id="openDiscountForm" onSubmit={this.handleSubmit} >
                        <InputTextComponent
                            placeholder={translator.getLabel("quantity")}
                            autoComplete="off" 
                            value={this.state.quantity} 
                            onValueChange={(value) => {this.state.quantity = value; this.setState({}) }}
                            inputTextType="numeric"
                            internalRef={this.inputFieldRef}
                            error={this.state.error.fieldName === "quantity" ? this.state.error.message : ''}
                        />
                    </Form>
                </ModalBody>
            </Modal>
        );
    }
}


export default ItemCount;